<template>
    <div>
        <div v-if="isPhone">
            <div class="to-pay-phone">
                <div class="to-pay-phone-price">
                    <span class="discount-price">￥{{learningDirection.discountPrice}}</span>
                    <span class="original-price">
                            原价：{{learningDirection.originalPrice}}</span>
                    <a-tag color="" class="discountDesc">{{learningDirection.discountDesc}}</a-tag>
                </div>

                <div class="button-pay">
                    <a-button type="danger" @click="showModal">立即购买</a-button>
                </div>
            </div>
        </div>


        <div v-else class="to-pay">
            <a-row>
                <a-col :span="12">
                    <a-row>
                        <a-col :span="16">
                            <span style="font-size: 24px">￥</span>
                            <span style="font-size: 34px;font-weight: bold">{{learningDirection.discountPrice}}</span>

                        </a-col>
                        <a-col :span="8">
                            <div v-if="$func.isTrue(learningDirection.isDiscount)">
                                <li>
                                    <a-tag color="" class="discountDesc">{{learningDirection.discountDesc}}</a-tag>
                                </li>
                                <li style="font-size: 14px;color: #999999;margin-left: 16px;text-decoration:line-through ">
                                    原价：{{learningDirection.originalPrice}}
                                </li>
                            </div>

                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="12" style="text-align: right;">
                    <a-button type="danger" @click="showModal">立即购买</a-button>
                </a-col>
            </a-row>
        </div>

        <div style="z-index: 1002">
            <!--        立即付款弹窗-->
            <a-modal v-model="showPay"
                     title="购买课程"
                     :cancelText="cancelText"
                     :okText="okText"
                     :confirmLoading="confirmLoading"
                     @ok="handleOk">
                <div class="modal" style="z-index: 1003">
                    <p style="margin-bottom: 20px">
                        课程方向：{{learningDirection.directionTitle}}
                    </p>
                    <p v-if="$func.isTrue(learningDirection.isDiscount)">课程价格：
                        <span style="text-decoration: line-through;color: #FF4F23;font-size: 14px;margin: 0 10px 0 0">￥{{learningDirection.originalPrice}}</span>
                        <span style="color: #E85A26;font-size: 18px;"
                              v-if="$func.isTrue(learningDirection.isDiscount)">￥{{learningDirection.discountPrice}}</span>
                    </p>
                    <p v-else>
                        课程价格：
                        <span style="color: #FF4F23;font-size: 14px;margin: 0 10px 0 0">￥{{learningDirection.originalPrice}}</span>
                    </p>
                </div>
            </a-modal>
        </div>


    </div>
</template>

<script>
    import common from "../../mixin/common";
    import {learningDirectionDetail, directionOrderCreate} from "@api/courseDirection-api";
    // import {showError} from "@utils/msg";
    import { showSuccessMsg, showMsg} from "@utils/msg";
    import {COURSE_ALREADY_PAID, SUCCESS} from "@constants/code";

    export default {
        name: "courseDirectionPay",
        mixins: [common],
        props: {
            directionId: {
                type: [Number, String],
            },
        },
        data() {
            return {
                isPhone: false,
                //学习方向数据
                learningDirection: {},
                //显示确认付款弹框
                showPay: false,
                cancelText: "取消",
                okText: "去付款",
                confirmLoading: false,
            }
        },
        created() {
            if (this.isMobile) {
                this.isPhone = true
            }
            // this.directionId = this.$route.query.directionId
            learningDirectionDetail(this.directionId).then((res) => {
                if (res.code === 0) {
                    if (res.canStudyDirection) {
                        //    跳转到学院专属课程详情
                        showSuccessMsg("您已购买该方向课程，快开始学习吧！");
                    } else {
                        //    跳转到返回的url
                        // this.$message.success("您未购买该方向课程，先来了解下课程体系吧！");
                        this.learningDirection = res.learningDirection
                    }
                }
            })
        },
        methods: {
            // 显示确认付款弹框
            showModal() {
                // this.modalData = item
                if (this.isLoginClick()) {
                    this.showPay = true;
                }
            },
            // 订单生成中
            handleOk() {
                this.confirmLoading = true;
                this.okText = "订单生成中...";
                directionOrderCreate(this.directionId).then((res) => {
                    if (res.code === SUCCESS) {
                        // todo 跳转到详情界面
                        showSuccessMsg("创建成功，即将跳转到支付界面...");
                        setTimeout(() => {
                            this.$router.push({
                                name: 'payDetail',
                                params: {
                                    orderId: res.order.orderId
                                }
                            })
                        }, 300)
                    } else if (res.code === COURSE_ALREADY_PAID) {
                        showMsg("已自动帮您忽略了您已拥有的课程");
                    }
                    this.confirmLoading = false;
                })
                // createOrder([this.courseId]).then(res => {
                //     if (res.code === SUCCESS) {
                //         // todo 跳转到详情界面
                //         this.$message.success("创建成功，即将跳转到支付界面...");
                //         setTimeout(() => {
                //             this.$router.push({
                //                 name: 'payDetail',
                //                 params: {
                //                     orderId: res.order.orderId
                //                 }
                //             })
                //         }, 300)
                //     } else if (res.code === COURSE_ALREADY_PAID) {
                //         this.$message.info("已自动帮您忽略了您已拥有的课程");
                //     } else {
                //         showError('创建订单失败', res.msg);
                //     }
                //     this.confirmLoading = true;
                // })
            }
        }
    }
</script>

<style scoped lang="less">
    /deep/ .ant-col-16 {
        width: auto;
    }

    /*响应式*/
    @import '../../styles/variable.less';

    @media screen and (min-width: @screen-lg) {
        /*.to-pay-mobile{*/
        /*    display: none;*/
        /*}*/
        /*.to-pay-phone{*/
        /*    position: fixed;*/
        /*    bottom: 0;*/
        /*    height: 50px;*/
        /*    width: 100%;*/
        /*    background: white;*/
        /*    display: flex;*/
        /*    flex-direction: row;*/
        /*    justify-content: space-between;*/
        /*    align-items:center;*/
        /*    padding: 8px;*/
        /*    !*margin-bottom: 10px;*!*/
        /*    border-top: 1px solid #F4F4F4;*/
        /*    .discountDesc{*/
        /*        padding: 0 5px;*/
        /*        margin: 0;*/
        /*        height: 20px;*/
        /*        line-height: 20px;*/
        /*        color: #FF4F23;*/
        /*        border: 1px solid #FF4F23;*/
        /*        !*margin-left: 10px;*!*/
        /*        background: rgba(255, 99, 42, .2);*/
        /*        text-align: center;*/
        /*        font-size: 14px;*/
        /*    }*/
        /*    .discountPrice{*/
        /*        font-size: 16px;*/
        /*        margin: 0 6px;*/
        /*    }*/
        /*    .button-pay{*/
        /*        float: right;*/
        /*        button {*/
        /*            width: 80px;*/
        /*            height: 30px;*/
        /*            font-size: 12px;*/
        /*            padding: 4px;*/
        /*        }*/
        /*    }*/
        /*}*/
    }

    .to-pay-mobile {
        width: 100%;
        /*height: 52px;*/
        /*line-height: 52px;*/

        .to-pay-phone-row {
            border-top: 1px solid #F4F4F4;
            padding-top: 10px;
            margin-bottom: 20px;
        }
    }

    /*.to-pay-phone{*/
    /*    display: none;*/
    /*}*/

    .to-pay {
        height: 138px;
        width: 1110px;
        margin: auto;
        border: 1px solid #e8e8e8;
        position: absolute;
        top: 0px;
        left: calc(50% - 550px);
        background: white;
        /*z-index: 1;*/
        box-shadow: 2px 2px 5px #4B4B4B;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, .3);
        padding: 40px 60px;

        button {
            width: 220px;
            height: 56px;
            font-size: 22px;
            /*background: #FF632A*/
        }

        .discountDesc {
            /*width: 100px;*/
            padding: 0 19px;
            height: 30px;
            line-height: 30px;
            color: #FF4F23;
            border: 1px solid #FF4F23;
            margin-left: 10px;
            background: rgba(255, 99, 42, .2);
            text-align: center;
            font-size: 16px;
        }
    }

    .to-pay-phone {
        position: fixed;
        bottom: 0;
        height: 50px;
        width: 100%;
        background: white;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        padding: 8px;
        /*margin-bottom: 10px;*/
        border-top: 1px solid #F4F4F4;
        z-index: 2002;

        .to-pay-phone-price {
            width: calc(100vw - 90px);
            text-align: left;
            color: #131313;

            .discountDesc {
                padding: 0 5px;
                margin: 0;
                height: 20px;
                line-height: 20px;
                color: #FF4F23;
                border: 1px solid #FF4F23;
                /*margin-left: 10px;*/
                background: rgba(255, 99, 42, .2);
                text-align: center;
                font-size: 12px;
            }

            .discount-price {
                font-size: 16px;
                margin: 0 6px;
            }

            .original-price {
                font-size: 12px;
                color: #999999;
                margin-right: 6px;
                text-decoration: line-through
            }
        }

        .button-pay {
            float: right;

            button {
                width: 80px;
                height: 30px;
                font-size: 12px;
                padding: 4px;
            }
        }
    }

</style>
